import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonServiceService } from '../../common-service.service';
import * as moment from 'moment-timezone';
import { environment } from 'src/environments/environment';
import { GlobalVariable } from '../../global-variable';
import { Store } from '@ngrx/store';
import { InitialState } from 'src/app/store/reducer';
import { CookiesService } from '../../cookies.service';


@Component({
  selector: 'app-sales-purchase-search',
  templateUrl: './sales-purchase-search.component.html',
  styleUrls: ['../global-search.component.scss']
})
export class SalesPurchaseSearchComponent implements OnInit {
  salesPurchaseFilterForm: FormGroup;
  @ViewChild('searchButton', { static: true }) searchButton: ElementRef;
  minDate = "2023-04-01"
  maxDate = moment().format('YYYY-MM-DD')
  financialYear = "2024"
  branches = []
  financialYears: any;
  dateFormat = 'YYYY-MM-DD';
  isLocaleDateFormat: boolean = true;

  constructor(public commonService: CommonServiceService,
    private cookiesService: CookiesService,
    private formBuilder: FormBuilder, private router: Router, private store: Store<InitialState>) {
    this.store.select('sharedReducers').subscribe((items) => {
      if (items.financeYear && items.financeYear.start_date && items.financeYear.end_date) {
        this.minDate = items.financeYear.start_date
        this.maxDate = this.commonService.getFinancialSession(moment(items.financeYear.end_date)) < this.commonService.getFinancialSession(moment()) ?
          moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      } else {
        let current_financial_year = JSON.parse(sessionStorage.getItem('current_financial_year'))
        if (!current_financial_year) {
          current_financial_year = JSON.parse(localStorage.getItem('current_financial_year'));
        }
        this.minDate = current_financial_year.start_date
        this.maxDate = this.commonService.getFinancialSession(moment(current_financial_year.end_date)) < this.commonService.getFinancialSession(moment()) ?
          moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
      }
    })
  }
  ngOnInit() {
    if (sessionStorage.getItem('current_financial_year')) {
      let financialYearObj = JSON.parse(sessionStorage.getItem('current_financial_year'))
      this.financialYear = this.commonService.getFinancialSession(moment(financialYearObj.start_date))
    } else {
      this.financialYear = this.commonService.getFinancialSession(moment());
      let startDate = `${this.financialYear}-04-01`
      let endDate = `${Number(this.financialYear) + 1}-03-31`
      let financialYearObject = {
        start_date: startDate,
        end_date: endDate
      }
      sessionStorage.setItem('current_financial_year', JSON.stringify(financialYearObject))
      this.cookiesService.setCookie('SYSTACC_FINANCIAL_YEAR', JSON.stringify(financialYearObject))
    }

    this.salesPurchaseFilterForm = this.formBuilder.group({
      start_date: ["", [Validators.required]],
      end_date: ["", [Validators.required]],
    })

    this.salesPurchaseFilterForm.controls.start_date.setValue(moment(this.minDate).format('YYYY-MM-DD'))
    this.salesPurchaseFilterForm.controls.end_date.setValue(moment(this.maxDate).format('YYYY-MM-DD'))
    		this.getGlobalSettingsFormattedDate()

  }


  search(values) {
    GlobalVariable.openModalStatus = false;
    if (values.start_date == null || values.start_date == "" || values.start_date == "Invalid Date" || values.start_date == "Invalid date") {
      values.start_date = ""
    }
    else {
      values.start_date = moment(values.start_date).format('YYYY-MM-DD')
    }
    if (values.end_date == null || values.end_date == "" || values.end_date == "Invalid Date" || values.end_date == "Invalid date") {
      values.end_date = ""
    }
    else {
      values.end_date = moment(values.end_date).format('YYYY-MM-DD')
    }
    localStorage.setItem("activeSalesPurchaseSearchQuery", JSON.stringify({
      "start_date": values.start_date,
      "end_date": values.end_date,
    }))

    this.router.navigateByUrl(`report/sales-purchase-report?start_date=${values.start_date}&end_date=${values.end_date}`)

  }

  reset() {
    GlobalVariable.openModalStatus = false;
    this.salesPurchaseFilterForm = this.formBuilder.group({
      start_date: [''],
      end_date: [''],
    })
    localStorage.removeItem('activeSalesPurchaseSearchQuery')
  }

  clickSearchButton() {
    this.searchButton.nativeElement.click()
  }

  async getGlobalSettingsFormattedDate() {
		let globalSettingConfig = this.commonService.globalSettingConfig;
		if(!globalSettingConfig || globalSettingConfig.length == 0) {
			globalSettingConfig = await this.commonService.getGlobalSettings();
		}

		let dateConfig = await this.commonService.getDateFormat('date_format')
		this.dateFormat = dateConfig.dateFormat
		this.isLocaleDateFormat = dateConfig.isLocaleDateFormat;
	}

}
